module.exports = __webpack_public_path__ + "static/media/NY.be2a3dba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/NY.jpg
// module id = 310
// module chunks = 0